import linkHandlerInitialize from '../modules/link-handler';

const initialize = () => {
    linkHandlerInitialize();
};

export default initialize;
